import component from './component'

export default {
    path: '/premonitoria',
    name: 'premonitoria',
    component: component
}



// WEBPACK FOOTER //
// ./src/components/premonitoria/transaccion/index.js